<app-crudbar #crudbar [title]="title" (onReady)="doComReady($event,'curdbar')">
</app-crudbar>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
    <div class="h-full border-2 border-green-400">
      <ng-container>
        <!-- <app-jckpi37-detail #detail (onReady)="detailPageReady($event)">
        </app-jckpi37-detail> -->
      </ng-container>
    </div>
  </mat-tab>
  <mat-tab #myTabDetail label="明細">
    <!-- <app-jcktl-tabedit [srv]="srv"></app-jcktl-tabedit> -->
  </mat-tab>
  <mat-tab #myTabAdvance label="進階">

  </mat-tab>
</mat-tab-group>